export let ComponentType = /*#__PURE__*/function (ComponentType) {
  ComponentType["BUTTON"] = "BUTTON";
  ComponentType["CHECKBOX"] = "CHECKBOX";
  ComponentType["CURRENCY"] = "CURRENCY";
  ComponentType["CUSTOM_ELEMENT"] = "CUSTOM_ELEMENT";
  ComponentType["DATEPICKER"] = "DATEPICKER";
  ComponentType["DROPDOWN"] = "DROPDOWN";
  ComponentType["FORMLAYOUT"] = "FORMLAYOUT";
  ComponentType["GRID"] = "GRID";
  ComponentType["GRID_ITEM"] = "GRID_ITEM";
  ComponentType["INPUT"] = "INPUT";
  ComponentType["INPUT_PASSWORD"] = "INPUT_PASSWORD";
  ComponentType["INPUT_UNIT"] = "INPUT_UNIT";
  ComponentType["INPUT_ZIP"] = "INPUT_ZIP";
  ComponentType["LINK"] = "LINK";
  ComponentType["RADIO_GROUP"] = "RADIO_GROUP";
  ComponentType["TEXTAREA"] = "TEXTAREA";
  ComponentType["TYPOGRAPHY"] = "TYPOGRAPHY";
  return ComponentType;
}({});
export let RenderConditionsType = /*#__PURE__*/function (RenderConditionsType) {
  RenderConditionsType["ALL"] = "all";
  RenderConditionsType["ONE_OF"] = "oneOf";
  return RenderConditionsType;
}({});